import { UseMutationResult } from 'react-query';
import { editorService } from '../../../services';
import { useFloorUsageTagMutation } from './use-floor-usage-tag-mutation';

export function useFloorUsageTagUpdate(): UseMutationResult<unknown, unknown, [number, TagCreate], unknown> {
    return useFloorUsageTagMutation(([tagId, tag]) => editorService.updateFloorUsageTag(tagId, tag));
}
